// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lable-title[data-v-30302d91]{width:80px;display:inline-block}", ""]);
// Exports
module.exports = exports;
